export const TabName = {
  fromManualAdd: 'Add New Manually',
  fromTemplate: 'From Template',
  fromProject: 'From Existing Project',
}
